import EventHandler from '@pixelunion/events';
import themeUtils from '../themeUtils';

export default class StaticNavigation {
  constructor(section) {
    this.el = section.el;
    this.events = new EventHandler();

    this.$navigationWrapper = $('[data-navigation-wrapper]', this.el);
    this.$navigationContent = $('[data-navigation-content]', this.el);
    this.$body = $(document.body);
    this.$height = $(window).height();

    this.reloadNavigation();
  }

  reloadNavigation() {
    this.events.unregisterAll();

    if (!themeUtils.isLessThanLarge()) {
      this.$navigationWrapper
        .detach()
        .insertAfter('[data-header-branding]');

      this.$navigationContent
        .removeClass('navigation-mobile')
        .addClass('navigation-desktop');
      this.$navigationContent.find('li[data-mega-nav="true"]')
        .removeClass('has-dropdown')
        .addClass('has-mega-nav');
    } else {
      this.$navigationWrapper
        .detach()
        .insertAfter('[data-header-main]');

      this.$navigationContent
        .removeClass('navigation-desktop')
        .addClass('navigation-mobile');
      this.$navigationContent.find('li[data-mega-nav="true"]')
        .removeClass('has-mega-nav')
        .addClass('has-dropdown');
    }

    this.el.querySelectorAll('.mega-nav-list li a').forEach(anchor => this.events.register(anchor, 'mouseover', this._onMegaNavAnchorMouseover.bind(this)));
    this.el.querySelectorAll('.mega-nav-list a').forEach(anchor => this.events.register(anchor, 'mouseover', this._onMegaNavAnchorMouseleave.bind(this)));
    this.el.querySelectorAll('[data-header-nav-toggle]').forEach(toggle => this.events.register(toggle, 'click', this._onMobileNavigationClick.bind(this)));
    this.events.register(window, 'resize', themeUtils.debounce(this._onResize.bind(this), 500));

    const currentCloseAction = {
      el: null,
      timeout: null,
    };
    this.el.querySelectorAll('.has-dropdown, .has-mega-nav').forEach(toggle => this.events.register(toggle, 'mouseenter', event => {
      if (themeUtils.isLessThanLarge()) return;

      const { currentTarget } = event;

      if (currentCloseAction.el && currentCloseAction.timeout) {
        clearTimeout(currentCloseAction.timeout);
        this._closeDropdown(currentCloseAction.el);
        currentCloseAction.el = null;
        currentCloseAction.timeout = null;
      }

      if (currentTarget.classList.contains('has-mega-nav')) {
        this._swapMegaNavImages($('.mega-nav-image img', currentTarget));
      }

      this._openDropdown(currentTarget);
    }));

    this.el.querySelectorAll('.has-dropdown, .has-mega-nav').forEach(toggle => this.events.register(toggle, 'mouseleave', event => {
      if (themeUtils.isLessThanLarge()) return;

      const { currentTarget } = event;

      if (currentCloseAction.el && currentCloseAction.timeout) {
        // Don't add another action for an element that is nested within a currently closing dropdown
        if (currentCloseAction.el.contains(currentTarget)) return;

        clearTimeout(currentCloseAction.timeout);

        // Close the current dropdown if one exists and hasn't been run, but only if it isn't a child of this new event
        if (!currentTarget.contains(currentCloseAction.el)) {
          this._closeDropdown(currentCloseAction.el);
        }
      }

      currentCloseAction.el = currentTarget;
      currentCloseAction.timeout = setTimeout(() => {
        this._closeDropdown(currentCloseAction.el);
        currentCloseAction.el = null;
        currentCloseAction.timeout = null;
      }, 400);
    }));

    this.el.querySelectorAll('.has-dropdown > a > [data-subnav-toggle]').forEach(toggle => this.events.register(toggle, 'click', event => {
      event.stopPropagation();
      event.preventDefault();

      const { currentTarget } = event;
      const triggerEl = currentTarget.parentElement.parentElement;

      if (triggerEl.classList.contains('has-dropdown--active')) {
        this._closeDropdown(triggerEl);
      } else {
        this._openDropdown(triggerEl);
      }
    }));

    this.el.querySelectorAll('.navigation-submenu').forEach(toggle => this.events.register(toggle, 'revealer-animating', event => {
      if (themeUtils.isLessThanLarge()) {
        return;
      }

      const $dropdown = $(event.currentTarget);

      if (!$dropdown.hasClass('animating-in')) {
        return;
      }

      $dropdown.removeClass('navigation-submenu-open-left');
      $dropdown.css('opacity', 0);
      $dropdown.css('display', 'block');
      const navigationWidth = this.$navigationWrapper.width();
      const offset = $dropdown.offset();

      if ((offset.left + 200) > navigationWidth) {
        $dropdown.addClass('navigation-submenu-open-left');
      }

      $dropdown.css('opacity', '');
      $dropdown.css('display', '');
    }));
  }

  onSectionDeselect() {
    this._toggleMobileNavigation('close');
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this._toggleMobileNavigation('close');
  }

  _onResize() {
    if (!themeUtils.isLessThanLarge()) {
      this._toggleMobileNavigation('close');
    }

    this.reloadNavigation();
  }

  _onMegaNavAnchorMouseover(e) {
    this._swapMegaNavImages(e.currentTarget.parentNode);
  }

  _onMegaNavAnchorMouseleave(e) {
    const megaNavImage = $(e.target)
      .closest('.mega-nav')
      .children('.mega-nav-image img');
    megaNavImage.attr('src', megaNavImage.data('image')).attr('alt', megaNavImage.data('alt'));
  }

  _onMobileNavigationClick() {
    this._toggleMobileNavigation();
  }

  _openDropdown(triggerEl) {
    triggerEl.classList.add('has-dropdown--active');

    const $dropdown = $(triggerEl).children('.navigation-submenu, .mega-nav');
    const $navigationSubmenuToggle = $(triggerEl).find('.navigation-submenu-toggle');

    if (themeUtils.isLessThanLarge()) {
      triggerEl.classList.add('has-mobile-dropdown--active');
      $dropdown.addClass('navigation-submenu-visible');
      this._setTierHeight();
    } else {
      $dropdown.revealer('show');
    }

    $navigationSubmenuToggle.attr('aria-expanded', true);
  }

  _closeDropdown(triggerEl) {
    triggerEl.classList.remove('has-dropdown--active');
    triggerEl.querySelectorAll('.has-dropdown, .has-mega-nav').forEach(innerTriggerEl => this._closeDropdown(innerTriggerEl));

    const $dropdown = $(triggerEl).children('.navigation-submenu, .mega-nav');
    const $navigationSubmenuToggle = $(triggerEl).find('.navigation-submenu-toggle');

    triggerEl.classList.remove('has-mobile-dropdown--active');
    $dropdown.removeClass('navigation-submenu-visible');
    $dropdown.revealer('hide');
    this._setTierHeight();

    $navigationSubmenuToggle.attr('aria-expanded', false);
  }

  _toggleMobileNavigation(force = null) {
    if (this.$body.hasClass('mobile-nav-open') && force !== 'open') {
      this.$navigationContent.removeAttr('style');
      this.$body.removeClass('mobile-nav-open lock-scroll');
      this.$navigationContent.removeClass('visible');
      this.$navigationWrapper.removeClass('visible background');

      // Close opened menus on navigation close
      this.$navigationContent[0].querySelectorAll('.has-dropdown--active').forEach(triggerEl => this._closeDropdown(triggerEl));
    } else if (!this.$body.hasClass('mobile-nav-open') && force !== 'close') {
      this.$body.addClass('mobile-nav-open lock-scroll');
      this.$navigationContent.addClass('visible');
      this.$navigationWrapper.addClass('visible background');
      this._setTierHeight();
    }
  }

  _setTierHeight() {
    this.$navigationContent.css({
      'overflow-y': 'scroll',
      height: '100%',
    });
  }

  _swapMegaNavImages(target) {
    const image = $(target).data('image');
    const imageAlt = $(target).data('image-alt');

    if (image && (image !== '')) {
      $(target)
        .closest('.mega-nav')
        .find('.mega-nav-image img')
        .attr('src', image)
        .attr('srcset', '')
        .attr('alt', imageAlt);
    }
  }
}
